import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Box, Snackbar, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { setFileds } from '../../../Store/Redux/file-list-slice.js';
import DropDown from '../drop-down.js';

function CkRecipientDropDown({
	isPdf,
	recipients,
	originalFile,
	setOriginalFile
}) {
	const isMobile = useMediaQuery('(max-width:768px)');
	const incrementer = isMobile ? 2 : 3;
	const [selectedSignRecp, setSelectedSignRecp] = useState([]);
	const [disable, setDisable] = useState(false);
	const [showmore, setShowmore] = useState(incrementer);
	const dispatch = useDispatch();
	const [templateRecipientFeilds, setTemplateRecipientFeilds] = useState([]);
	const { recpInput } = useSelector((state) => state.fileList);
	const [recpList, setRecpList] = useState([]);
	const [snackBar, setSnackBar] = useState(false);
	const [snackBarmsg] = useState('');

	useEffect(() => {
		if (recipients.length > 0) {
			setRecpList(recipients);
		}
	}, [recipients]);

	useEffect(() => {
		if (originalFile) {
			const rfields = [];

			if (originalFile?.templateConfig?.fields) {
				for (const el of originalFile?.templateConfig?.fields ?? []) {
					if (
						el.isrecipient === 'recipient'
					&& rfields.length < recipients.length
					) {
						el.uuid = recipients[rfields.length].id;
						const re = recpInput.find((r) => r.inputId === el.id && r.inval);
						if (re) {
							el.selectedId = [re.inval];
						}

						rfields.push(el);
					}
				}
			}

			setTemplateRecipientFeilds(rfields);
		}
	}, [originalFile]);

	useEffect(() => {
		if (recpInput.length > 0) {
			setSelectedSignRecp([...recpInput]);
		}
	}, [recpInput]);

	const handleClearRecipientDropdown = (e, inputId) => {
		if (isPdf) {
			return;
		}

		const { name, value } = e.target;

		const allData = { ...originalFile };

		const updateRecipient = selectedSignRecp?.map((el) =>
			el?.inputId === inputId
				? {
					...el,
					name,
					value,
					inval: '',
					inputId
				}
				: el
		);
		setSelectedSignRecp(updateRecipient);
		dispatch(setFileds(updateRecipient));

		const templateRecipients = templateRecipientFeilds.map((e) => {
			if (e.id === inputId) {
				return { ...e, selectedId: [] };
			}

			return e;
		});

		setTemplateRecipientFeilds(templateRecipients);
		if (allData?.templateConfig?.fields) {
			const arr = allData?.templateConfig?.fields;
			for (const el of arr) {
				if (el.id === inputId) {
					el.value = '';
				}
			}
		}

		setOriginalFile(allData);
	};

	const handleRecipientDropdown = (e, inputId, index) => {
		if (isPdf) {
			return;
		}

		const { name, value } = e.target;
		const getRecipient = recipients.find((el) => el.id === e.target.value);
		if (!getRecipient) {
			return;
		}

		const Alrady
			= selectedSignRecp?.length > 0
			&& selectedSignRecp?.find((el) => el?.value && el?.value === value);
		if (Alrady) {
			toast.error('This Recipient Already selected', {
				position: 'bottom-center',
				toastId: 'custom-tab-content-error-2'
			});
			return;
		}

		const checkRecipient
			= selectedSignRecp?.length > 0
			&& selectedSignRecp?.find((el) => el?.name === name);

		if (checkRecipient) {
			const updateRecipient = selectedSignRecp?.map((el) =>
				el?.name === name
					? {
						...el,
						name,
						value,
						inval: getRecipient.userData.firstName,
						inputId
					}
					: el
			);
			setSelectedSignRecp(updateRecipient);
			dispatch(setFileds(updateRecipient));
		} else {
			const newR = [...selectedSignRecp];
			newR[index] = {
				name,
				value,
				inval: getRecipient.userData.firstName,
				inputId
			};
			dispatch(setFileds(newR));
			setSelectedSignRecp(newR);
		}

		const templateRecipients = templateRecipientFeilds.map((e) => {
			if (e.id === inputId) {
				return { ...e, selectedId: [getRecipient.userData.firstName] };
			}

			return e;
		});

		setTemplateRecipientFeilds(templateRecipients);

		const allData = { ...originalFile };
		if (allData?.templateConfig?.fields) {
			const arr = allData?.templateConfig?.fields;
			for (const el of arr) {
				if (el.placeholder === name && el.isrecipient === 'recipient') {
					el.value = getRecipient.userData.firstName;
				}
			}
		}

		setOriginalFile(allData);

		setTimeout(() => {
			setDisable(false);
		}, 600);
	};

	const handleShowmore = () => {
		if (showmore > 10) {
			return;
		}

		const fullVal = isMobile ? 8 : 7;
		setShowmore((preValue) => preValue + fullVal);
	};

	const handleShowLess = () => {
		if (showmore < 3) {
			return;
		}

		setShowmore(incrementer);
	};

	return (
		<>
			<Snackbar
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				open={snackBar}
				autoHideDuration={4000}
				onClose={() => setSnackBar(!snackBar)}
				message={snackBarmsg}
			/>
			<Box display={'flex'} flexDirection={'column'} rowGap={1}>
				{templateRecipientFeilds?.slice(0, showmore).map((item, index) => (
					<DropDown
						key={item.id}
						disabled={disable}
						width={isMobile ? '95%' : '100%'}
						height={isMobile ? '38px' : '45px'}
						placeholder={item.fieldname}
						name={item.fieldname}
						showClear={true}
						handleChange={(e) => handleRecipientDropdown(e, item.id, index)}
						dropdownValue={recpList.map((el) => ({
							...el.userData,
							id: el.id,
							name: el.userData.firstName
						}))}
						dropDownSelected={[item.selectedId || '']}
						handleClearSelection={(e) =>
							handleClearRecipientDropdown(e, item.id)
						}
					/>
				))}
				<Box mt={0.5} display={'flex'} columnGap={1}>
					{templateRecipientFeilds?.length > incrementer
					&& showmore === incrementer ? (
							<Box
								className='medium5 pointer-css green-color'
								onClick={() => handleShowmore()}
							>
							Show more{' '}
							</Box>
						) : (
							''
						)}
					{showmore === 10 && (
						<Box
							className='medium5 pointer-css green-color'
							onClick={() => handleShowLess()}
						>
							Show less{' '}
						</Box>
					)}
				</Box>
			</Box>
		</>
	);
}

export default CkRecipientDropDown;

CkRecipientDropDown.propTypes = {
	isPdf: PropTypes.any,
	recipients: PropTypes.any,
	originalFile: PropTypes.any,
	setOriginalFile: PropTypes.any
};
